import axios from 'axios'

const baseAPIUrl = process.env.VUE_APP_API_URL

import store from '../store/index'

/**
 * Pose la déconnexion sur session expirée en intercepteur de réponse.
 *
 * AD-104 : cet effet de bord vivait dans validateStatus, dont le seul rôle est
 * de dire si un statut est un succès. Ce mélange lui faisait retourner une
 * valeur non booléenne, et les réponses 400 et 401 étaient acceptées comme
 * valides au lieu d'être rejetées.
 *
 * @param instance
 * @returns {*}
 */
function withSessionGuard(instance) {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Disconnect
        store.dispatch('logout', true)
        window.location.href = 'login'
      }

      return Promise.reject(error)
    }
  )

  return instance
}

export default {
  /**
   * Call API for all request
   *
   * @returns {*}
   */
  callApi() {
    return withSessionGuard(
      axios.create({
        baseURL: baseAPIUrl,
        withCredentials: false,
        params: {
          locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'fr'
        },
        headers: {
          common: {
            Accept: 'application/json'
          },
          patch: {
            'Content-Type': 'application/json'
          },
          Authorization: 'Bearer ' + localStorage.getItem('auth.userToken')
        }
      })
    )
  },
  /**
   * Call API for file downloads (exports, archives)
   *
   * Pas de paramètre locale : les téléchargements n'en envoyaient pas.
   *
   * @param accept type de fichier attendu
   * @returns {*}
   */
  callApiFile(accept) {
    return withSessionGuard(
      axios.create({
        baseURL: baseAPIUrl,
        withCredentials: false,
        responseType: 'blob',
        headers: {
          common: {
            Accept: accept
          },
          Authorization: 'Bearer ' + localStorage.getItem('auth.userToken')
        }
      })
    )
  },
  /**
   * Get user token
   *
   * @param data
   * @returns {*}
   */
  getToken(data) {
    return axios.post(baseAPIUrl + '/login', data)
  }
}
